<template>
  <v-data-table
    dense
    class="vf-table"
    :headers="tableFields"
    :items="recentRoutes"
    :loading="loading"
    :loading-text="$t('loading')">
    <template #item.name="row">
      <router-link :to="`/route/${row.item.id}`">
        {{ row.value }}
      </router-link>
    </template>
    <template #item.start="row">
      <multi-time-display :time="row.value"/>
    </template>
    <template #item.end="row">
      <if-set :value="row.value">
        <multi-time-display :time="row.value"/>
        <template #not-set>
          <span class="not-set">({{ $t('in_progress') }})</span>
        </template>
      </if-set>
    </template>
    <template v-for='column in routeProductColumns' #[`item.${column.value}`]="row">
      <route-product-status
        :route="row.item"
        :route-product="get(row.item.product_indexed_route_products, column.product_id)"
        :key="column.value"/>
    </template>
  </v-data-table>
</template>

<script>
import RouteProductStatus from '@/components/route/RouteProductStatus'
import IfSet from '@/components/shared/IfSet'
import MultiTimeDisplay from '@/components/shared/MultiTimeDisplay'
import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'
import { each, get, map } from 'lodash'

export default {
  name: 'VehicleRecentRoutes',
  components: {
    RouteProductStatus,
    MultiTimeDisplay,
    IfSet
  },
  mixins: [
    CurrentUserMixin
  ],
  props: {
    vehicle: Object
  },
  data () {
    return {
      loading: false,
      recentRoutes: []
    }
  },
  computed: {
    /**
     * The fields to use in the table.
     */
    tableFields () {
      const fields = [
        {
          value: 'name',
          text: this.$tc('route'),
          sortable: false
        },
        {
          value: 'start',
          text: this.$t('start'),
          sortable: false
        },
        {
          value: 'end',
          text: this.$t('end'),
          sortable: false
        }
      ]
      each(this.routeProductColumns, x => {
        fields.push(x)
      })
      return fields
    },
    /**
     * Build a list of route product columns to display in the table. This will get added to the base list of columns.
     * @returns Array
     */
    routeProductColumns () {
      const result = []
      // Build a map of product ids to product names by iterating through each route's route products.
      const productsMap = {}
      each(this.recentRoutes, route => {
        each(route.route_products, routeProduct => {
          productsMap[routeProduct.product_id] = get(routeProduct, 'product.name', this.$t('unknown'))
        })
      })
      // Create column entries
      each(productsMap, (name, id) => {
        result.push({
          text: name,
          product_id: id,
          value: `product_${id}`,
          sortable: false,
          align: 'end'
        })
      })
      return result
    }
  },
  methods: {
    get: get,
    async fetchRecentRoutes () {
      try {
        this.loading = true
        const expand = [
          'route_products.product',
          'route_products.violations'
        ]
        const fields = [
          'id',
          'name',
          'start',
          'end',
          'route_products.*'
        ]
        // We'd like to show all the routes associated with this vehicle, even on customers other than the currently
        // selected customer context.
        const userCustomerIds = map(this.customers, c => c.id)
        // get the 15 most recent routes.
        const response = await this.$orm('Route').findAll({
          vehicle_id: this.vehicle.id,
          customer_id: userCustomerIds.join(','),
          expand: expand.join(','),
          fields: fields.join(','),
          'per-page': 15,
          sort: '-end'
        })
        this.recentRoutes = response.getItems()
      } catch (error) {
        this.handleError(error)
      } finally {
        this.loading = false
      }
    }
  },
  mounted () {
    this.fetchRecentRoutes()
  }
}
</script>

<style scoped>

</style>
